/*
  LS Silk Size Finder (product page widget)
  Vanilla JS. Reads the JSON rendered by snippets/size-finder.liquid and drives the
  <modal-dialog id="SizeFinder-{section}"> it renders. Recommendation rules are plain,
  deterministic lookups on the product's size profile (a Shopify metaobject).
  Nothing is added to the cart: "Select size" only changes the product's size option.
*/
(function () {
  'use strict';

  var AU_SIZES = ['6', '8', '10', '12', '14', '16'];
  // Usual-size labels per sizing system, keyed by the AU/NZ size the profile's map uses.
  // Standard women's conversion: AU/NZ = UK; US = AU - 4; EU = AU + 28.
  // Each system carries the unit its shoppers expect; choosing a system sets the unit (the cm/inches switch can still override).
  var SYSTEMS = {
    au: { label: 'AU/NZ', unit: 'cm', sizes: { '6': '6', '8': '8', '10': '10', '12': '12', '14': '14', '16': '16' } },
    us: { label: 'US', unit: 'in', sizes: { '6': '2', '8': '4', '10': '6', '12': '8', '14': '10', '16': '12' } },
    uk: { label: 'UK', unit: 'cm', sizes: { '6': '6', '8': '8', '10': '10', '12': '12', '14': '14', '16': '16' } },
    eu: { label: 'EU', unit: 'cm', sizes: { '6': '34', '8': '36', '10': '38', '12': '40', '14': '42', '16': '44' } }
  };
  var EU_COUNTRIES = 'AT BE BG HR CY CZ DK EE FI FR DE GR HU IS IT LV LI LT LU MT NL NO PL PT RO SK SI ES SE CH'.split(' ');
  // Starting system from the visitor's country (Shopify sets window.Shopify.country from the market / localisation).
  function systemForCountry(code) {
    code = String(code || '').toUpperCase();
    if (code === 'US') return 'us';
    if (code === 'GB' || code === 'IE') return 'uk';
    if (EU_COUNTRIES.indexOf(code) !== -1) return 'eu';
    return 'au';
  }
  var CM_PER_IN = 2.54;
  var GARMENT_ROWS = [
    ['bust', 'Bust'],
    ['waist', 'Waist'],
    ['hip', 'Hip'],
    ['hem', 'Hem'],
    ['length', 'Length']
  ];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function num(v) {
    var n = parseFloat(v);
    return isFinite(n) && n > 0 ? n : null;
  }
  function inRange(r, x) {
    return Array.isArray(r) && r.length === 2 && x >= r[0] && x <= r[1];
  }
  function toUnit(cm, unit) {
    if (cm == null || cm === '') return cm;
    if (unit !== 'in') return cm;
    var v = Math.round((cm / CM_PER_IN) * 10) / 10;
    return Number.isInteger(v) ? v : v.toFixed(1);
  }
  function fmtRange(r, unit) {
    return Array.isArray(r) && r.length === 2 ? toUnit(r[0], unit) + '–' + toUnit(r[1], unit) : '–';
  }

  function SizeFinder(modal, data, sid) {
    this.modal = modal;
    this.data = data;
    this.sid = sid;
    this.draft = /[?&]sf_draft=1(&|$)/.test(location.search) || !!(window.Shopify && window.Shopify.designMode);
    this.sizes = Array.isArray(data.sizes) ? data.sizes : [];
    this.quickMap = data.quickMap && typeof data.quickMap === 'object' ? data.quickMap : {};
    this.sizeIndex = Array.isArray(data.options) ? data.options.indexOf(data.sizeOption) : -1;
    this.variants = Array.isArray(data.variants) ? data.variants : [];
    this.state = { au: null, fit: null, mode: 'quick', m: {} };
    this.system = systemForCountry(window.Shopify && window.Shopify.country);
    this.unit = SYSTEMS[this.system].unit;

    var v = data.verified || {};
    var self = this;
    this.unverified = { quick: v.quick !== true, measure: v.measure !== true, chart: v.chart !== true };
    this.show = {
      quick: (v.quick === true || this.draft) && Object.keys(this.quickMap).length > 0,
      measure:
        (v.measure === true || this.draft) &&
        this.sizes.some(function (s) {
          return s.body && Array.isArray(s.body.bust);
        }),
      chart: (v.chart === true || this.draft) && this.sizes.length > 0
    };
    this.el = {
      quick: modal.querySelector('[data-sf-block="quick"]'),
      fit: modal.querySelector('[data-sf-block="fit"]'),
      measure: modal.querySelector('[data-sf-block="measure"]'),
      result: modal.querySelector('[data-sf-block="result"]'),
      nodata: modal.querySelector('[data-sf-block="nodata"]'),
      chart: modal.querySelector('[data-sf-block="chart"]'),
      au: modal.querySelector('[data-sf-au]'),
      fitPills: modal.querySelectorAll('[data-sf-fit] .size-finder__pill'),
      toggle: modal.querySelector('[data-sf-measure-toggle]'),
      mHeading: modal.querySelector('[data-sf-measure-heading]'),
      mFields: modal.querySelector('[data-sf-measure-fields]'),
      waistField: modal.querySelector('[data-sf-waist-field]'),
      hipField: modal.querySelector('[data-sf-hip-field]'),
      sizeLine: modal.querySelector('[data-sf-size-line]'),
      resultSize: modal.querySelector('[data-sf-result-size]'),
      resultTitle: modal.querySelector('[data-sf-result-title]'),
      why: modal.querySelector('[data-sf-result-why]'),
      fitNote: modal.querySelector('[data-sf-fit-note]'),
      select: modal.querySelector('[data-sf-select]'),
      note: modal.querySelector('[data-sf-result-note]'),
      chartBody: modal.querySelector('[data-sf-chart]'),
      draftNote: modal.querySelector('[data-sf-draft-note]'),
      systems: modal.querySelector('[data-sf-systems]'),
      unitGroups: modal.querySelectorAll('[data-sf-units]'),
      unitLabels: modal.querySelectorAll('[data-sf-unit-label]')
    };
    this.build();

    // Re-check availability whenever the modal opens (the colour may have changed meanwhile).
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (self.modal.hasAttribute('open')) self.compute();
      }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    }
  }

  SizeFinder.prototype.build = function () {
    var self = this;
    var el = this.el;
    var show = this.show;

    el.quick.hidden = !show.quick;
    el.fit.hidden = !(show.quick || show.measure);
    el.measure.hidden = !show.measure;
    el.nodata.hidden = show.quick || show.measure;
    el.chart.hidden = !show.chart;
    if (!show.quick) this.modal.classList.add('size-finder--no-numbers');

    // Draft badges (preview only)
    var draftShown = false;
    ['quick', 'measure', 'chart'].forEach(function (k) {
      var badge = self.modal.querySelector('[data-sf-badge="' + k + '"]');
      var on = self.draft && show[k] && self.unverified[k];
      if (badge) badge.hidden = !on;
      if (on) draftShown = true;
    });
    el.draftNote.hidden = !draftShown;

    // Step 1: usual sizes, shown in the chosen sizing system
    if (show.quick) {
      this.renderAuPills();
      if (el.systems) {
        var current = el.systems.querySelector('[data-system="' + this.system + '"]');
        if (current) this.setPressed(el.systems, current);
        el.systems.addEventListener('click', function (e) {
          var b = e.target.closest('[data-system]');
          if (!b || !SYSTEMS[b.getAttribute('data-system')]) return;
          self.system = b.getAttribute('data-system');
          self.setPressed(el.systems, b);
          self.renderAuPills();
          self.setUnit(SYSTEMS[self.system].unit); // also re-renders the chart and the result
        });
      }
      el.au.addEventListener('click', function (e) {
        var b = e.target.closest('[data-au]');
        if (!b || b.disabled) return;
        self.state.au = b.getAttribute('data-au');
        self.state.mode = 'quick';
        self.setPressed(el.au, b);
        if (self.el.toggle && !el.toggle.hidden) self.setMeasureOpen(false);
        self.compute();
      });
    }

    // Step 2: fit
    Array.prototype.forEach.call(el.fitPills, function (b) {
      b.addEventListener('click', function () {
        self.state.fit = b.getAttribute('data-fit');
        self.setPressed(b.parentNode, b);
        self.compute();
      });
    });

    // Measurements
    if (show.measure) {
      var needWaist = this.sizes.some(function (s) {
        return s.body && Array.isArray(s.body.waist);
      });
      el.waistField.hidden = !needWaist;
      this.needHip = this.sizes.some(function (s) {
        return s.body && Array.isArray(s.body.hip);
      });
      if (el.hipField) el.hipField.hidden = !this.needHip;
      if (show.quick) {
        el.toggle.addEventListener('click', function () {
          self.setMeasureOpen(el.toggle.getAttribute('aria-expanded') !== 'true');
        });
      } else {
        el.toggle.hidden = true;
        el.mHeading.hidden = false;
        el.mFields.hidden = false;
        this.state.mode = 'measure';
      }
      Array.prototype.forEach.call(el.mFields.querySelectorAll('input'), function (input) {
        input.addEventListener('input', function () {
          self.state.m[input.getAttribute('data-sf-m')] = self.readMeasure(input);
          self.state.mode = 'measure';
          self.compute();
        });
      });
    }

    // Units (cm / inches): one handler for both switches
    Array.prototype.forEach.call(el.unitGroups, function (group) {
      group.addEventListener('click', function (e) {
        var b = e.target.closest('[data-unit]');
        if (!b) return;
        self.setUnit(b.getAttribute('data-unit'));
      });
    });
    this.applyUnit();

    // Size chart
    if (show.chart) el.chartBody.innerHTML = this.renderChart();

    // Select size
    el.select.addEventListener('click', function () {
      self.select();
    });
  };

  SizeFinder.prototype.renderAuPills = function () {
    var self = this;
    var sys = SYSTEMS[this.system] || SYSTEMS.au;
    this.el.au.innerHTML = AU_SIZES.map(function (s) {
      var ok = !!self.quickMap[s];
      var label = sys.sizes[s];
      var pressed = self.state.au === s ? 'true' : 'false';
      return (
        '<button type="button" class="size-finder__pill" data-au="' + s + '" aria-pressed="' + pressed + '"' +
        (ok ? '' : ' disabled aria-label="' + sys.label + ' size ' + label + ', not available for this piece yet"') + '>' + label + '</button>'
      );
    }).join('');
  };

  SizeFinder.prototype.usualLabel = function (au) {
    var sys = SYSTEMS[this.system] || SYSTEMS.au;
    return this.system === 'au' ? 'AU/NZ size ' + au : sys.label + ' size ' + sys.sizes[au] + ' (AU/NZ ' + au + ')';
  };

  SizeFinder.prototype.setUnit = function (unit) {
    this.unit = unit === 'in' ? 'in' : 'cm';
    this.applyUnit();
    if (this.show.chart) this.el.chartBody.innerHTML = this.renderChart();
    this.compute();
  };

  SizeFinder.prototype.applyUnit = function () {
    var unit = this.unit;
    Array.prototype.forEach.call(this.el.unitGroups, function (group) {
      Array.prototype.forEach.call(group.querySelectorAll('[data-unit]'), function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-unit') === unit ? 'true' : 'false');
      });
    });
    Array.prototype.forEach.call(this.el.unitLabels, function (l) { l.textContent = unit === 'in' ? 'in' : 'cm'; });
  };

  // Measurement inputs are read in the chosen unit and kept in cm.
  SizeFinder.prototype.readMeasure = function (input) {
    var n = num(input.value);
    return n == null ? null : (this.unit === 'in' ? n * CM_PER_IN : n);
  };

  SizeFinder.prototype.setPressed = function (group, active) {
    Array.prototype.forEach.call(group.querySelectorAll('[aria-pressed]'), function (b) {
      b.setAttribute('aria-pressed', b === active ? 'true' : 'false');
    });
  };

  SizeFinder.prototype.setMeasureOpen = function (open) {
    var el = this.el;
    el.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    el.mFields.hidden = !open;
    el.mHeading.hidden = !open;
    this.state.mode = open ? 'measure' : 'quick';
    if (open) {
      this.state.au = null;
      this.setPressed(el.au, null);
      var first = el.mFields.querySelector('input');
      if (first) first.focus();
    }
    this.compute();
  };

  SizeFinder.prototype.sizeByLabel = function (label) {
    for (var i = 0; i < this.sizes.length; i++) if (this.sizes[i].label === label) return this.sizes[i];
    return null;
  };

  // Returns {label, why, confident} or null when the inputs are incomplete.
  SizeFinder.prototype.recommend = function () {
    var st = this.state;
    var fit = st.fit;
    var fitWord = fit === 'relaxed' ? 'relaxed' : 'closer';

    if (st.mode === 'quick') {
      if (!st.au) return null;
      var m = this.quickMap[st.au];
      if (!m) return null;
      // A map entry with only a message means this usual size is outside what we make: say so, honestly, before asking for a fit.
      if (m.message && !m.closer && !m.relaxed) {
        return { label: null, confident: false, why: m.message, title: 'A note on sizing' };
      }
      if (!fit) return null;
      var label = m[fit] || m.closer || m.relaxed;
      if (!label) return null;
      var why = 'Based on your usual ' + this.usualLabel(st.au) + ' and a ' + fitWord + ' fit.';
      if (fit === 'relaxed' && m.closer && m.relaxed && m.closer !== m.relaxed) {
        why += ' We’ve gone up a size for a looser fall.';
      }
      return { label: label, why: why, confident: true };
    }

    // Measurement method
    if (!fit) return null;
    var useHip = !!this.needHip;
    var bust = st.m.bust;
    var hip = useHip ? st.m.hip : null;
    var waist = st.m.waist;
    if (!bust || (useHip && !hip)) return null;
    var sizes = this.sizes;
    var body = sizes.filter(function (s) {
      return s.body && Array.isArray(s.body.bust) && (!useHip || Array.isArray(s.body.hip));
    });
    if (!body.length) return null;
    var largest = body[body.length - 1];
    var smallest = body[0];
    var unitWord = this.unit === 'in' ? ' in' : ' cm';
    var cv = function (cm) { return toUnit(cm, this.unit) + unitWord; }.bind(this);
    var hipText = function (s, idx) { return useHip ? ' and hips of ' + cv(s.body.hip[idx]) : ''; };
    if (bust > largest.body.bust[1] || (useHip && hip > largest.body.hip[1])) {
      return {
        label: null, confident: false, title: 'A note on sizing',
        why: 'Our largest size, ' + largest.label + ', fits up to a bust of ' + cv(largest.body.bust[1]) + hipText(largest, 1) +
          '. Your measurements are above that, so this piece would be too close a fit. We’d rather say so now than disappoint you.'
      };
    }
    if (bust < smallest.body.bust[0] && (!useHip || hip < smallest.body.hip[0])) {
      return {
        label: null, confident: false, title: 'A note on sizing',
        why: 'Our smallest size, ' + smallest.label + ', is made for a bust from ' + cv(smallest.body.bust[0]) +
          (useHip ? ' and hips from ' + cv(smallest.body.hip[0]) : '') + '. Your measurements are below that, so this piece would sit loose.'
      };
    }
    var waistOk = function (s) {
      return !waist || !Array.isArray(s.body.waist) || inRange(s.body.waist, waist);
    };
    var hipOk = function (s) { return !useHip || inRange(s.body.hip, hip); };
    var both = body.filter(function (s) {
      return inRange(s.body.bust, bust) && hipOk(s) && waistOk(s);
    });
    var self = this;
    var u = this.unit === 'in' ? ' in' : ' cm';
    var show = function (cm) { return toUnit(Math.round(cm * 10) / 10, self.unit) + u; };
    var measured = 'your bust (' + show(bust) + ')' + (useHip ? ' and hips (' + show(hip) + ')' : '') + (waist ? ' and waist (' + show(waist) + ')' : '');
    var pick, sizedUp = false, text;

    if (both.length) {
      pick = fit === 'relaxed' ? both[both.length - 1] : both[0];
      if (fit === 'relaxed' && both.length === 1 && sizes[sizes.indexOf(pick) + 1]) {
        pick = sizes[sizes.indexOf(pick) + 1];
        sizedUp = true;
      }
      text = 'Based on ' + measured + ' and a ' + fitWord + ' fit.';
      if (sizedUp) text += ' We’ve gone up a size for a looser fall.';
      else if (both.length > 1) text += ' You sit between sizes, so we’ve chosen the ' + (fit === 'relaxed' ? 'roomier' : 'closer') + ' one.';
      return { label: pick.label, why: text, confident: true };
    }

    var bs = body.filter(function (s) { return inRange(s.body.bust, bust); });
    var hs = useHip ? body.filter(function (s) { return inRange(s.body.hip, hip); }) : bs;
    if (!bs.length || !hs.length) {
      return { label: null, confident: false, why: 'We can’t confidently recommend a size from these measurements.' };
    }
    var base = Math.max(sizes.indexOf(bs[0]), sizes.indexOf(hs[0]));
    pick = sizes[base];
    if (fit === 'relaxed' && sizes[base + 1]) {
      pick = sizes[base + 1];
      sizedUp = true;
    }
    text = 'Your bust suggests size ' + bs[0].label + ' and your hips size ' + hs[0].label + '. We recommend the larger size so it sits comfortably';
    text += sizedUp ? ', and have gone up again for a relaxed fit.' : '.';
    return { label: pick.label, why: text, confident: true };
  };

  SizeFinder.prototype.currentOptions = function () {
    var picker = document.getElementById('variant-selects-' + this.sid);
    var json = picker && picker.querySelector('[data-selected-variant]');
    if (json) {
      try {
        var v = JSON.parse(json.textContent);
        if (v && Array.isArray(v.options)) return v.options;
      } catch (e) { /* fall through */ }
    }
    return this.variants.length ? this.variants[0].options : [];
  };

  // Does the recommended size exist as a variant, and is it available with the other options as chosen now?
  SizeFinder.prototype.variantFor = function (value) {
    var idx = this.sizeIndex;
    if (idx < 0) return { exists: false, available: false };
    var current = this.currentOptions();
    var exists = false, available = false;
    this.variants.forEach(function (v) {
      if (!Array.isArray(v.options) || v.options[idx] !== value) return;
      exists = true;
      var match = v.options.every(function (o, i) { return i === idx || current[i] == null || o === current[i]; });
      if (match && v.available) available = true;
    });
    return { exists: exists, available: available };
  };

  SizeFinder.prototype.compute = function () {
    var el = this.el;
    var rec = this.recommend();
    if (!rec) {
      el.result.hidden = true;
      return;
    }
    el.result.hidden = false;
    el.fitNote.hidden = true;
    el.note.hidden = true;

    if (el.resultTitle) el.resultTitle.textContent = rec.title || 'Your recommended size';
    if (!rec.confident) {
      el.sizeLine.hidden = true;
      el.select.hidden = true;
      var chartHint = this.show.chart
        ? ' See the size chart below'
        : this.data.sizeChartUrl
          ? ' See our <a href="' + esc(this.data.sizeChartUrl) + '">size chart</a>'
          : '';
      el.why.innerHTML = esc(rec.why) + chartHint + (chartHint ? ', or ' : ' Please ') +
        '<a href="' + esc(this.data.contactUrl || '/pages/contact-us') + '">contact us</a> if you’d like a hand.';
      if (this.show.chart) el.chart.open = true;
      return;
    }

    var size = this.sizeByLabel(rec.label);
    var value = size && size.variant_value ? size.variant_value : rec.label;
    var vf = this.variantFor(value);

    el.sizeLine.hidden = false;
    el.resultSize.textContent = rec.label;
    el.why.textContent = rec.why;
    if (this.data.fitNote) {
      el.fitNote.textContent = this.data.fitNote;
      el.fitNote.hidden = false;
    }
    el.select.hidden = false;
    el.select.textContent = 'Select size ' + rec.label;
    el.select.disabled = !vf.available;
    el.select.setAttribute('data-value', value);
    if (!vf.exists) {
      el.note.textContent = 'Size ' + rec.label + ' isn’t offered for this piece. Please check the size chart or contact us.';
      el.note.hidden = false;
    } else if (!vf.available) {
      el.note.textContent = 'Size ' + rec.label + ' is currently sold out in this colour.';
      el.note.hidden = false;
    }
  };

  // Select the size in the theme's own variant picker. Dawn's <variant-selects> listens for the
  // bubbling change event and re-renders price, media and the buy buttons as if the shopper had clicked.
  SizeFinder.prototype.select = function () {
    var value = this.el.select.getAttribute('data-value');
    var picker = document.getElementById('variant-selects-' + this.sid);
    var host = picker && picker.querySelector('[data-size-finder-option]');
    if (!value || !host) return;
    var target = null;
    Array.prototype.forEach.call(host.querySelectorAll('input[type="radio"]'), function (input) {
      if (input.value === value) target = input;
    });
    if (target) {
      if (!target.checked) {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else {
      var select = host.querySelector('select');
      if (!select) return;
      if (select.value !== value) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    this.modal.hide();
  };

  SizeFinder.prototype.renderChart = function () {
    var self = this;
    var sizes = this.sizes;
    var showAu = this.show.quick;
    var unit = this.unit;
    var sys = SYSTEMS[this.system] || SYSTEMS.au;
    var unitName = unit === 'in' ? 'inches' : 'cm';
    // Body ranges belong to the measurement method: show them only once that method is verified (or in draft preview).
    var hasBody = this.show.measure && sizes.some(function (s) { return s.body; });
    var hasGarment = sizes.some(function (s) { return s.garment; });
    var cols = sizes.length + 1;
    var h = '<div class="size-finder__table-wrap"><table class="size-finder__table">';
    h += '<thead><tr><th scope="col">LS Silk size</th>';
    sizes.forEach(function (s) { h += '<th scope="col">' + esc(s.label) + '</th>'; });
    h += '</tr></thead><tbody>';

    if (showAu) {
      h += '<tr><th scope="row">Usual ' + esc(sys.label) + ' size</th>';
      sizes.forEach(function (s) {
        var aus = AU_SIZES.filter(function (a) {
          var m = self.quickMap[a];
          return m && m.closer === s.label;
        }).map(function (a) { return sys.sizes[a]; });
        h += '<td>' + (aus.length ? esc(aus.join(', ')) : '–') + '</td>';
      });
      h += '</tr>';
    }

    if (hasBody) {
      h += '<tr class="size-finder__group"><th colspan="' + cols + '">To fit · your body<small>Recommended body measurements, ' + unitName + '</small></th></tr>';
      [['bust', 'Bust'], ['waist', 'Waist'], ['hip', 'Hips']].forEach(function (row) {
        if (!sizes.some(function (s) { return s.body && Array.isArray(s.body[row[0]]); })) return;
        h += '<tr><th scope="row">' + row[1] + '</th>';
        sizes.forEach(function (s) { h += '<td>' + fmtRange(s.body && s.body[row[0]], unit) + '</td>'; });
        h += '</tr>';
      });
    }

    if (hasGarment) {
      h += '<tr class="size-finder__group"><th colspan="' + cols + '">The garment · laid flat<small>The piece’s own measurements, ' + unitName + '</small></th></tr>';
      GARMENT_ROWS.forEach(function (row) {
        if (!sizes.some(function (s) { return s.garment && s.garment[row[0]] != null; })) return;
        h += '<tr><th scope="row">' + row[1] + '</th>';
        sizes.forEach(function (s) {
          var val = s.garment && s.garment[row[0]];
          h += '<td>' + (val == null ? '–' : esc(toUnit(val, unit))) + '</td>';
        });
        h += '</tr>';
      });
    }
    h += '</tbody></table></div>';
    if (hasBody && hasGarment) {
      h += '<p class="size-finder__fine">Body measurements are what you measure on yourself. Garment measurements are the piece itself, laid flat.</p>';
    }
    return h;
  };

  function init(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-size-finder-data]'), function (dataEl) {
      if (dataEl.dataset.sfReady) return;
      var sid = dataEl.getAttribute('data-size-finder-data');
      var modal = document.getElementById('SizeFinder-' + sid);
      if (!modal || !modal.querySelector('[data-sf-block="result"]')) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      dataEl.dataset.sfReady = '1';
      new SizeFinder(modal, data, sid);
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  // Any link to #find-my-size (for example in the product description) opens the widget.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href="#find-my-size"]');
    if (!link) return;
    var modal = document.querySelector('modal-dialog.size-finder');
    if (!modal || typeof modal.show !== 'function') return;
    e.preventDefault();
    modal.show(link);
  });
})();
